import React from 'react'
import image from "../../Assets/dummy";


const ClientsSec = () => {
  return (
    <div >
      <div className='flex justify-center'>
        <p className='text-center text-24  underline underline-offset-3 font-medium '>
          Our Clients
        </p>
      </div>

      <div className="flex justify-between mt-5 items-center flex-wrap" >
        
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.canarabank} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.Casagrand} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.emco} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.muscatsteel} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.emirates} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.bahraingalvanizing} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.gastrocare} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.holycross} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.sriAndal} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.madrasNetworking} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.noormuscat} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.NEZOoilfield} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.ocentra} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.orbitalfarication} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.SRIBALAJIMEDICALCOLLEGE} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.vkapolymers} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.pacifichightech} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.skyway} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.westpoint} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.parkeroil} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.KMSPECIALITY} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.poonacollege} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.jenomaranbuilders} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.permasteelisa} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.sivachidambaramjewellery} alt="" />
         <img loading="lazy" className=" h-12 m-3 max-[850px]:max-2 " src={image.vailakanni} alt="" />
      
      </div>
     
    </div>
  )
}

export default ClientsSec
